import makeActionCreator from 'redux/utils/makeActionCreator';
import types from './types';

// Loadings
export const setAppointment = makeActionCreator(types.SET_APPOINTMENT, 'appointment');
export const setWebConfig = makeActionCreator(types.SET_WEB_CONFIG, 'webConfig');
export const setAppPromptClose = makeActionCreator(types.SET_APP_PROMPT_CLOSE, 'appPromptClose');
export const setLanguageSelection = makeActionCreator(types.SET_LANGUAGE_SELECTION, 'languageSelection');
export const setFirebaseRemoteConfigs = makeActionCreator(types.SET_FIREBASE_REMOTE_CONFIGS, 'firebaseRemoteConfigs');
export const setDeleteAccRequest = makeActionCreator(types.SET_DELETE_ACC_REQUEST, 'deleteAccRequest');
export const setDoctors = makeActionCreator(types.SET_DOCTORS, 'doctorsList');
